export default __webpack_public_path__ + "static/media/business-12.3724fcc9.jpg";